import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ApiConfigState {
  skipTraceId: boolean;
}

const initialState: ApiConfigState = {
  skipTraceId: false,
};

const apiConfigSlice = createSlice({
  name: 'apiConfig',
  initialState,
  reducers: {
    setSkipTraceId: (state, action: PayloadAction<boolean>) => {
      state.skipTraceId = action.payload;
    },
    resetSkipTraceId: (state) => {
      state.skipTraceId = false;
    },
  },
});

export const { setSkipTraceId, resetSkipTraceId } = apiConfigSlice.actions;
export default apiConfigSlice.reducer;
